import React, { useEffect, useState }             from 'react'
import {
  Box,
  Button,
  Container,
  FormControl,
  Grid,
  Input,
  InputLabel,
  Paper,
  Typography,
}                                                 from '@mui/material'
import { useTranslation }                         from 'react-i18next'
import { useNavigate, useParams }                 from 'react-router-dom'
import { useApi }                                 from '../../utils/api'
import { useSnackbar }                            from 'notistack'
import AlertSimpleDialog                          from '../../components/alert-simple-dialog'
import Page                                       from '../../components/Page'

export default function PartnerPage() {

  const api = useApi()
  const navigate = useNavigate()
  const { partnerId } = useParams()
  const { enqueueSnackbar } = useSnackbar()
  const { t } = useTranslation()
  const [values, setValues] = useState({
    name: '',
  })
  const [shownDeleteDialog, setShownDeleteDialog] = useState(false)

  useEffect(() => {
    (async () => {
      if (!isNaN(partnerId)) {
        try{
          let partner = await api.partner.detail(partnerId)
          setValues({
            name: '',
            ...partner
          })
        } catch (e){
          enqueueSnackbar(t('Can\'t load partner'), {
            variant: "error"
          })
        }
      }
    })()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [partnerId])

  const handleChange = (prop) => (event) => {
    setValues({ ...values, [prop]: event.target.value })
  }

  const handleCloseDeleteDialog = (result) => {
    setShownDeleteDialog(false)
    if (result) {
      api.partner.delete(partnerId).then(() => {
        enqueueSnackbar(t('Partner deleted'), {
          variant: 'success'
        })
        navigate('/dashboard/partners')
      }).catch(error => {
        enqueueSnackbar(t('Failed to delete partner'), {
          variant: 'error'
        })
      })
    }
  }

  const onSubmit = async (e) => {
    e.preventDefault()
    let data = { ...values }
    try {
      let partner = await api.partner.save(data)
      navigate(`/dashboard/partners/${partner.id}`)
      enqueueSnackbar(t('Partner saved'), {
        variant: 'success'
      })
    } catch (e) {
      enqueueSnackbar(t('Failed to save partner'), {
        variant: 'error'
      })
    }
  }

  return (
    <Page title={t('Partner')}>
      <Container component="main">
        <Typography component="h1" variant="h3" sx={{ flexGrow: 1, mb: 2 }}>
          {t('Partner')}
        </Typography>
        <Grid component={'form'} onSubmit={onSubmit} item xs={12}>
          <Paper sx={{ p: 2, width: '100%' }}>
            <Grid container sx={{ width: '100%' }} spacing={2}>
              <Grid item xs={12}>
                <FormControl fullWidth variant="standard">
                  <InputLabel htmlFor="user-name">{t('Name')}</InputLabel>
                  <Input
                    id="user-name"
                    value={values.name}
                    onChange={handleChange('name')}
                  />
                </FormControl>
              </Grid>
            </Grid>
          </Paper>
          <Box sx={{ mt: 2, px: 1 }}>
            <Button type={'submit'} variant={'contained'}>{t('Save')}</Button>
            { !isNaN(partnerId) && (<Button type={'button'} color={'error'} variant={'contained'} sx={{ ml: 2 }} onClick={() => { setShownDeleteDialog(true) }}>{t('Delete')}</Button>) }
          </Box>
        </Grid>
        <AlertSimpleDialog
          title={t('Deleting partner')}
          message={t('delete-confirm-msg', { name: values.name })}
          open={shownDeleteDialog}
          onClose={handleCloseDeleteDialog}
        />
      </Container>
    </Page>
  )
}